import type { Router } from "vue-router";

const RELOAD_GUARD_KEY = "stale-chunk-reload";
const RELOAD_GUARD_MS = 10_000;

const STALE_CHUNK_PATTERNS = [
	"Failed to fetch dynamically imported module",
	"Unable to preload CSS for",
	"Importing a module script failed",
	"error loading dynamically imported module",
];

export const isStaleChunkError = (error: unknown): boolean => {
	const message = error instanceof Error ? error.message : String(error ?? "");
	return STALE_CHUNK_PATTERNS.some((pattern) => message.includes(pattern));
};

const reloadOnce = (): void => {
	try {
		const lastReloadAt = Number(sessionStorage.getItem(RELOAD_GUARD_KEY) ?? "0");
		if (Date.now() - lastReloadAt < RELOAD_GUARD_MS) {
			return;
		}
		sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
	} catch {
		// sessionStorage может быть недоступен — всё равно пробуем перезагрузить
	}

	window.location.reload();
};

export const setupStaleChunkReload = (router?: Router): void => {
	if (import.meta.env.DEV) {
		return;
	}

	window.addEventListener("vite:preloadError", (event) => {
		event.preventDefault();
		reloadOnce();
	});

	window.addEventListener("unhandledrejection", (event) => {
		if (!isStaleChunkError(event.reason)) {
			return;
		}
		event.preventDefault();
		reloadOnce();
	});

	router?.onError((error) => {
		if (isStaleChunkError(error)) {
			reloadOnce();
		}
	});
};
